<template>
  <div class="teq-container">
    <div class="input-container">
      <input
          type="text"
          :placeholder="placeholderSearch"
          class="input_search"
          v-model="query"
          @input="lunchAutoComplete"
          @change="selectResult"
          @keyup.enter="selectResult"
      />
      <div class="btn-close"  v-if="query.length > 0">
        <svg class="icon icon-close" @click="reset()">
          <use xlink:href="#icon-close"></use>
        </svg>
      </div>
    </div>

    <search-auto-complete
        :results="results"
        :query="query"
        :text-cta="textCta"
        :no-resu="noResuAutoComplete"
        v-if="!list && results"
    ></search-auto-complete>


    <div class="filter-total" >
      <div class="total">
        <span>{{ totalResult }} {{ totalResult <= 1 ? resultTextSingular : resultTextPlural }}</span>
      </div>
      <filter-by
          v-if="!noResuAutoComplete"
          @filterSelected="filterSelected = $event"
          :query="query"
          :baseUrl="baseUrl"
          :filterList="filtersWithResults"
          @list="list = $event"
          @totalResult="totalResult = $event"
          @totalPage="totalPages = $event"
          @noResult="noResu = $event"
          @pageNum="pagenum = $event"
          :filterText="filterText"
      ></filter-by>
    </div>

    <div class="noresult"  v-if="(list == null || list.length == 0) && noResu == true">
      0 {{resultTextSingular}}
    </div>

    <div class="container-result" v-if="list">
      <template v-for="(item, index) in list">
        <search-item
            :item="item"
            :key="index"
            :assetUrl="assetsUrl"
            v-if="typeof item == 'object'"
        ></search-item>
      </template>
    </div>

    <div
        role="button"
        class="btn-primary"
        @click="loadMore()"
        v-if="list && pagenum < totalPages"
    >
      {{ seeMore }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
import searchAutoComplete from "./searchAutocomplete";
import searchItem from "./searchItem.vue";
import filterBy from "./filterBy.vue";
import customSelect from "custom-select";
export default {
  components: {
    searchAutoComplete,
    searchItem,
    filterBy,
  },
  data() {
    return {
      query: "",
      results: null,
      list: null,
      totalPages: null,
      totalResult: null,
      pagenum: 1,
      noResu: false,
      filterSelected: "",
      textCta: "",
      noResuAutoComplete : null,
      filtersWithResults: this.filterList,
      timeOutTyping: null,
    };
  },
  props: {
    baseUrl: {
      type: String,
      required: true,
    },
    placeholderSearch: {
      type: String,
      required: true,
    },
    noResult: {
      type: String,
      required: true,
    },
    assetsUrl: {
      type: String,
      required: true,
    },
    resultTextSingular: {
      type: String,
      required: true,
    },
    resultTextPlural: {
      type: String,
      required: true,
    },
    seeMore: {
      type: String,
      required: true,
    },
    filterText: {
      type: String,
      required: true,
    },
    filterList: {
      type: Array,
      required: true,
    },
    nbQueryLimitMobile: {
      type: String,
      required: true
    },
    nbQueryLimitDesktop: {
      type: String,
      required: true
    },
    seeMoreAutocomplete: {
      type: String,
      required: true
    },
    launchSearchAutocomplete: {
      type: String,
      required: true
    },
  },

  methods: {
    async lunchAutoComplete() {
      clearTimeout(this.timeOutTyping);
      let that = this;
      this.timeOutTyping = setTimeout(function () {
        that.getSearchResultAutoComplete();
      }, 300);

    },
    async getSearchResultAutoComplete() {
      const ApiUrl = this.baseUrl + "autocompletesearch?term=";
      const lang = document.documentElement.lang;
      const minDataLength = null;
      if (this.query.length < 3) {
        this.noResu = false
      }
      if (this.query.length >= 3) {
        document.querySelector('.filter-total').classList.remove('active')
      }
      try {
        let data ='';
        if (this.query.length >= 3) {
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            data = await axios.get(
                ApiUrl + this.query + "&lang_current=" + lang + "&query_limit=" + this.nbQueryLimitMobile
            );
            this.minDataLength = 3;
          } else {
            data = await axios.get(
                ApiUrl + this.query + "&lang_current=" + lang + "&query_limit=" + this.nbQueryLimitDesktop
            );
            this.minDataLength = 5;
          }

          this.results = data.data;

          // Define Autocomplete CTA text depending of device and size of results
          if (data.data.total > this.minDataLength){
            this.textCta = this.seeMoreAutocomplete;
          }else{
            this.textCta = this.launchSearchAutocomplete;
          }

          this.noResu = false;
          if (this.results.length === 0) this.noResu = true;
          if (data.data.total){
            this.noResuAutoComplete = false
          }else{
            this.noResuAutoComplete = true
          }

          this.list = null;

        }
      } catch (error) {
        return error;
      }
    },
    async selectResult() {

      if(this.query.length < 3){
        this.noResu = true;
        return;
      }
      const ApiUrL = this.baseUrl + "search?term=";
      const lang = document.documentElement.lang;
      try {

        const data = await axios.get(
            ApiUrL + this.query + "&page=1" + "&lang_current=" + lang
        );
        this.list = data.data;
        if (this.list.length == 0) this.noResu = true;
        this.totalPages = data.data.totalpages;
        if(data.data.total > 0){
          this.totalResult = data.data.total;
          document.querySelector('.filter-total').classList.add('active')
        }else{
          this.totalResult = 0;
          document.querySelector('.filter-total').classList.remove('active')
        }

        this.filterFilters();

      } catch (error) {
        return error;
      }
    },

    async loadMore() {
      const ApiUrL = this.baseUrl + "search?term=";
      const newPage = this.pagenum + 1;
      const lang = document.documentElement.lang;
      try {
        if (this.filterSelected !== "") {
          const data = await axios.get(
              ApiUrL + this.query + "&page=" + newPage + "&filter=" + this.filterSelected + "&lang_current=" + lang
          );
          let newData = data.data;
          delete newData.total;
          delete newData.totalpages;
          this.list = Object.values(this.list).concat(Object.values(newData));
        } else {
          const data = await axios.get(
              ApiUrL + this.query + "&page=" + newPage + "&lang_current=" + lang
          );
          let newData = data.data;
          delete newData.total;
          delete newData.totalpages;
          this.list = Object.values(this.list).concat(Object.values(newData));
        }

        this.pagenum = newPage;
      } catch (error) {
        return error;
      }

      // Add new array to first Array
    },

     filterFilters(){
      this.filterSelected = "";
       this.filtersWithResults = [];
       let filters = [];
       let arr = [];

       for (let i = 0; i < Object.values(this.filterList[0]).length; i++) {
         if(!arr.includes(Object.values(this.filterList[0])[i])){
           arr.push(Object.values(this.filterList[0])[i]);
           let key = `nb_${Object.values(this.filterList[0])[i]}`;
           if(this.list[key] != 0){
             filters.push([Object.values(this.filterList[0])[i], this.list[key]]);
           }
         }
       }

       let arr2 = [];
       let obj = {};
       for (let i = 0; i < filters.length; i++) {
         if(!arr2.includes(filters[i][0])) {
           arr2.push(filters[i][0]);
           this.filtersWithResults[''+filters[i][0]+''] = filters[i][0];
           obj[''+filters[i][0]+''] = filters[i][0];
         }
       }

       this.filtersWithResults.push(obj);
    },
    reset() {
      this.query = "";
      this.results = null;
      this.list = null;
      this.totalPages = null;
      this.totalResult = null;
      this.pagenum = 1;
      this.noResu = false;
      this.filterSelected = "";
      this.textCta = "";
      document.querySelector('.filter-total').classList.remove('active')
    },
  },

};
</script>
